import { useEffect } from 'react'
import { useSearchParams, Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@apollo/client'
import { Stack, Button } from '@mui/material'

import EmptyScreen from 'packages/ui/EmptyScreen/EmptyScreen'

import LoginPage from '../Login/pages/LoginPage'
import { OPERATION_ME } from '../Me'

const Me = () => {
  const { loading, error, data } = useQuery(OPERATION_ME)
  const {t} = useTranslation()
  const [searchParams] = useSearchParams()
  useEffect(() => {
    if (data) {
      window.location.href = `${process.env.REACT_APP_API_URL}/${searchParams.get('redirect_url')}`
    }
  }, [data])
  if (loading) {
    return <EmptyScreen icon="gauge-high">{t('ui_elements.loading')}</EmptyScreen>
  } else if (error) {
    return (
      <EmptyScreen icon="gauge-high">
        <Stack gap={1}>
          {t('identity_provider.error_session')}
          <Button
            size={'small'}
            variant={'contained'}>
            {t('identity_provider_login')}
          </Button>
        </Stack>
      </EmptyScreen>
    )
  }
  return null
}

const IdentityProvider = () => {
  const [searchParams] = useSearchParams()
  const {t} = useTranslation()
  if (searchParams.get('action') === 'auth') {
    return <LoginPage identityProviderRedirectUrl={`${process.env.REACT_APP_API_URL}/${searchParams.get('redirect_url')}`} />
  } else if (searchParams.get('error')) {
    return <EmptyScreen icon="gauge-high">{t('identity_provider.error', {code: searchParams.get('error')})}</EmptyScreen>
  } else if (searchParams.get('action') === 'logout') {
    return <Navigate to={'/auth/logout'} />
  }
  return (
    <Me />
  )
}

export default IdentityProvider